<template>
  <ProblemListStep
    v-if="state.matches('reportProblemFlow.problemListStep')"
    :customerRequestId
    :mostUrgentTask
    :problemTypes
    :productReturnState
    :send
    :shouldShowSendMessageTitle
  />
  <DetailsStep
    v-if="state.matches('reportProblemFlow.detailsStep')"
    :customerRequestId
    :mostUrgentTask
    :productReturnState
    :send
    :state
    @done="emit('done')"
  />
</template>

<script setup lang="ts">
import type { ProductReturnState } from '~/api/care-folders/types/care-folder'
import type {
  OrderlineOpenTask,
  ProblemType,
} from '~/api/seller-after-sales/types'

import type { MachineSend, MachineState } from '../../ActionBar.machine.type'

import DetailsStep from './DetailsStep/DetailsStep.vue'
import ProblemListStep from './ProblemListStep/ProblemListStep.vue'

defineProps<{
  problemTypes: ProblemType[]
  send: MachineSend
  state: MachineState
  customerRequestId: number
  shouldShowSendMessageTitle?: boolean
  mostUrgentTask?: OrderlineOpenTask
  productReturnState: ProductReturnState
}>()

const emit = defineEmits(['done'])
</script>
